import React, { useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "../../modal/Modal";
import GLOBAL from "../../../global";

const HeightForm = ({ isShow, updateBiometricData, isUpdatingUserData }) => {
    // Synchronize with GLOBAL.USER_INFO which is now populated from GetMeasuredExercises API
    const [biometricData, setBiometricData] = useState({
        Height: 0,
        Weight: 0,
        DominantHand: '',
        Gender: ''
    });

    React.useEffect(() => {
        if (isShow) {
            setBiometricData({
                Height: GLOBAL.USER_INFO?.Height || 0,
                Weight: GLOBAL.USER_INFO?.Weight || 0,
                DominantHand: GLOBAL.USER_INFO?.DominantHand || '',
                Gender: GLOBAL.USER_INFO?.Gender || ''
            });
        }
    }, [isShow]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setBiometricData(prev => ({
            ...prev,
            [name]: name === 'Height' || name === 'Weight' ? +value : value
        }));
    }

    const submitHandler = (e) => {
        e.preventDefault();
        updateBiometricData(biometricData);
    }

    const isFormValid = biometricData.Height > 0 && 
                       biometricData.Weight > 0 && 
                       biometricData.DominantHand && 
                       biometricData.Gender;

    return (
        <>
            <Modal isOpen={isShow} className="height-form-modal biometric-form-modal">
                <ModalHeader>
                    <strong>Input Height</strong>
                </ModalHeader>
                <ModalBody>
                    <div className="biometric-form__group">
                        <div className="biometric-form__input-item">
                            <label>Height (Inch):</label>
                            <input
                                type="number"
                                name="Height"
                                value={biometricData.Height}
                                onChange={handleChange}
                                className="height-form__input"
                            />
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <div className="d-flex-center-center">
                        {isUpdatingUserData ?
                            <button
                                className="height-form__button height-form__button--loading"
                                disabled={true}
                                type="button"
                            >
                                <i className="fa fa-spinner fa-spin"/>
                                &nbsp;Saving...
                            </button>
                            :
                            <button
                                className="height-form__button"
                                disabled={biometricData.Height <= 0}
                                type="button"
                                onClick={submitHandler}
                            >
                                Submit
                            </button>
                        }
                    </div>
                </ModalFooter>
            </Modal>
        </>
    );
}

export default HeightForm;